import { render, staticRenderFns } from "./VisitSecuItemList.vue?vue&type=template&id=0bfe5f70&scoped=true"
import script from "./VisitSecuItemList.vue?vue&type=script&lang=js"
export * from "./VisitSecuItemList.vue?vue&type=script&lang=js"
import style0 from "./VisitSecuItemList.vue?vue&type=style&index=0&id=0bfe5f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe5f70",
  null
  
)

export default component.exports